<script lang="ts">
  import { t } from '$i18n/index';
  import { registerServiceWorker } from '$infra/sw-registration';

  let updateReady = $state(false);
  let dismissed = $state(false);

  // Registration is a side effect of mounting the shell, not of module import,
  // so a unit test importing this component does not touch the SW registry.
  const sw = registerServiceWorker((state) => {
    if (state.updateReady !== undefined) updateReady = state.updateReady;
  });

  const visible = $derived(updateReady && !dismissed);
</script>

{#if visible}
  <!-- A hint, not a modal: it does not trap focus, block the screen, or come
       back if dismissed. Interrupting someone mid-Catch to talk about our
       release process would be exactly the wrong trade. -->
  <aside aria-live="polite">
    <p>{t('update.ready')}</p>
    <div class="actions">
      <button type="button" onclick={() => (dismissed = true)}>{t('update.dismiss')}</button>
      <button type="button" onclick={() => void sw.applyUpdate()}>{t('update.action')}</button>
    </div>
  </aside>
{/if}

<style>
  aside {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
    flex-wrap: wrap;
    padding: var(--space-3) var(--space-4);
    background: var(--c-surface);
    border-bottom: 1px solid var(--c-line);
    color: var(--c-ink-muted);
    font-size: var(--step--1);
  }

  .actions {
    display: flex;
    gap: var(--space-2);
  }

  button {
    padding: var(--space-2) var(--space-3);
    border-radius: var(--radius);
    border: 1px solid var(--c-line);
    color: var(--c-ink);
    min-height: var(--tap-min);
  }
</style>
